import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Styles from './RulesDescription.module.scss';
import ShowMorePopUp from '@/components/houses/_reusable/houseInfo/ShowMorePopUp/ShowMorePopUp';
import Typography from '@/components/UI/typography/Typography';
interface RulesDescriptionTypes {
  description: string;
}
const RulesDescription: FC<RulesDescriptionTypes> = ({
  description
}) => {
  const words = description?.split(' ');
  const limitedWords = words?.slice(0, 30);
  const limitedText = limitedWords?.join(' ');
  return <Box className={Styles['rules-description-content']} data-sentry-element="Box" data-sentry-component="RulesDescription" data-sentry-source-file="RulesDescription.tsx">
      <Box className={Styles['header-rules-item']} data-sentry-element="Box" data-sentry-source-file="RulesDescription.tsx">
        <Icon name="note-text" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="RulesDescription.tsx" />
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="RulesDescription.tsx">سایر قوانین </Typography>
      </Box>
      <Box className={Styles['description-rules-item']} data-sentry-element="Box" data-sentry-source-file="RulesDescription.tsx">
        {words?.length > 30 ? <>
            <Typography variant="bodyM" className={Styles['description-rules-text']}>
              {`${limitedText}...`}
            </Typography>{' '}
            <Box className={Styles['show-more-buttont']}>
              <ShowMorePopUp title="moreRules">
                <Typography variant="bodyL" color="neutral_800" className={Styles['description']} component="p">
                  {description}
                </Typography>
              </ShowMorePopUp>
            </Box>
          </> : <Typography variant="bodyM" color="neutral_800" className={Styles['description-rules-text']}>
            {limitedText}
          </Typography>}
      </Box>
    </Box>;
};
export default RulesDescription;